// Angular
import { ParsedAnimationResult } from '@angular/compiler/src/animation/animation_parser';
import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable()
export class NgxMissingHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (params.interpolateParams) {
        return params.interpolateParams["Default"] || params.key;
      }
      return '[MISSING]' + params.key;
  }

  constructor() {}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/shared/ngx-missing-handler.ts